import { render } from "./EditAdress.vue?vue&type=template&id=469409d7"
import script from "./EditAdress.vue?vue&type=script&lang=js"
export * from "./EditAdress.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/orders.cash-mere.ch/releases/80909800/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__